import React from "react";
import * as PropTypes from "prop-types";
import { exportButtons } from "../../constants";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import styleConstants from "../../styleConstants";

const StackedColumnChart = props => {
  let options = {
    chart: {
      type: "column",
      height: props.height,
      backgroundColor: null,
      style: {
        fontFamily: "'Source Sans Pro', sans-serif;",
        overflow: "visible"
      }
    },
    title: {
      text: null
    },
    plotOptions: {
      column: {
        stacking: !props.absolute ? "percent" : "normal",
        pointWidth: 24,
        borderWidth: 0,
        dataLabels: {
          enabled: false
        }
      }
    },
    xAxis: {
      categories: props.categories,
      labels: {
        style: {
          fontSize: "0.75rem",
          color: "black",
          textTransform: "uppercase"
        }
      },
      plotLines: props.plotLineValues.map(plotLineValue => ({
        value: plotLineValue,
        color: styleConstants.colors.gray4,
        width: 1,
        zIndex: 1
      })),
      lineColor: styleConstants.colors.gray6,
      gridLineColor: styleConstants.colors.gray4
    },
    yAxis: {
      title: {
        text: props.yAxisTitle
      },
      labels: {
        formatter: !props.absolute
          ? function() {
              return `${this.value}%`;
            }
          : null,
        style: {
          fontSize: "0.875rem",
          color: styleConstants.colors.gray4
        }
      },
      reversedStacks: props.reversedStacks,
      lineColor: styleConstants.colors.gray6,
      gridLineDashStyle: "ShortDot",
      gridLineColor: styleConstants.colors.gray4
    },
    series: props.series,
    tooltip: {
      backgroundColor: "white",
      useHTML: true,
      outside: true,
      formatter: props.tooltipFormatter,
      style: {
        fontSize: "0.875rem",
        color: styleConstants.colors.gray6
      },
      enabled: !!props.tooltipFormatter
    },
    legend: {
      width: props.legendWidth,
      reversed: props.reversedLegend
    },
    exporting: {
      buttons: {
        contextButton: {
          menuItems: exportButtons
        }
      },
      enabled: false
    },
    credits: {
      enabled: false
    }
  };

  if (props.legendPosition === "right") {
    options = {
      ...options,
      legend: {
        ...options.legend,
        layout: "vertical",
        align: "right",
        verticalAlign: "middle"
      }
    };
  }

  return (
    <HighchartsReact
      ref={props.innerRef}
      highcharts={Highcharts}
      options={options}
    />
  );
};

StackedColumnChart.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  yAxisTitle: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.string).isRequired,
  series: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(PropTypes.number).isRequired
    })
  ).isRequired,
  reversedStacks: PropTypes.bool,
  reversedLegend: PropTypes.bool,
  plotLineValues: PropTypes.arrayOf(PropTypes.number),
  legendPosition: PropTypes.oneOf(["bottom", "right"]),
  legendWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  absolute: PropTypes.bool,
  tooltipFormatter: PropTypes.func
};

StackedColumnChart.defaultProps = {
  height: "100%",
  yAxisTitle: null,
  reversedStacks: false,
  reversedLegend: false,
  plotLineValues: [],
  legendPosition: "right",
  legendWidth: 100,
  tooltipFormatter: function(tooltip) {
    return tooltip.defaultFormatter.call(this, tooltip);
  }
};

export default React.forwardRef((props, ref) => (
  <StackedColumnChart innerRef={ref} {...props} />
));
